module.exports = __webpack_public_path__ + "static/media/2-custom-cut-mat-board-for-ikea-SILVERHOJDEN-frame-(16in-x-12in-(41cm-x-31cm).284a8640.webp";